/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ArchitectureInputs */

const en_architecture = /** @type {(inputs: ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architecture`)
};

const es_architecture = /** @type {(inputs: ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitectura`)
};

const fr_architecture = /** @type {(inputs: ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architecture`)
};

const de_architecture = /** @type {(inputs: ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architektur`)
};

const ja_architecture = /** @type {(inputs: ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アーキテクチャ`)
};

const zh_architecture = /** @type {(inputs: ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`架构设计`)
};

const ar_architecture = /** @type {(inputs: ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الهيكلة والتصميم`)
};

const id_architecture = /** @type {(inputs: ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arsitektur`)
};

const it_architecture = /** @type {(inputs: ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Architettura`)
};

const ru_architecture = /** @type {(inputs: ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Архитектура`)
};

const pt_architecture = /** @type {(inputs: ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquitetura`)
};

const ko_architecture = /** @type {(inputs: ArchitectureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아키텍처`)
};

/**
* | output |
* | --- |
* | "Architecture" |
*
* @param {ArchitectureInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const architecture = /** @type {((inputs?: ArchitectureInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ArchitectureInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_architecture(inputs)
	if (locale === "es") return es_architecture(inputs)
	if (locale === "fr") return fr_architecture(inputs)
	if (locale === "de") return de_architecture(inputs)
	if (locale === "ja") return ja_architecture(inputs)
	if (locale === "zh") return zh_architecture(inputs)
	if (locale === "ar") return ar_architecture(inputs)
	if (locale === "id") return id_architecture(inputs)
	if (locale === "it") return it_architecture(inputs)
	if (locale === "ru") return ru_architecture(inputs)
	if (locale === "pt") return pt_architecture(inputs)
	return ko_architecture(inputs)
});